import { Box, TextField, Tooltip, IconButton } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import { CustomSelect } from './CustomSelect';
import { SearchField } from './SearchField';
const FilterBar = ({
  filters,
  dateErrors = {},
  onSectionChange,
  onSearchChange,
  onPeriodChange,
  onDateChange,
  sections,
  periods,
  showPeriodFilter = false,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: '1rem',
        paddingRight: '1rem',
        alignItems: 'center',
      }}
    >
      {showPeriodFilter && (
        <>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              marginRight: 2,
            }}
          >
            <CustomSelect
              value={filters.period || 'Últimos 7 días'}
              setValue={onPeriodChange}
              field={'period'}
              items={periods}
              label={'Período'}
              disableClearable={true}
            />
            <Tooltip
              title={`El período seleccionado filtra las notas según su fecha de última actualización.`}
              placement="top"
              arrow
            >
              <IconButton
                size="small"
                sx={{
                  color: 'text.secondary',
                  '&:hover': {
                    color: 'primary.main',
                    backgroundColor: 'rgba(25, 118, 210, 0.04)',
                  },
                }}
              >
                <InfoOutlined fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>

          {filters.period === 'Personalizado' && (
            <>
              <TextField
                label="Fecha inicio"
                type="date"
                value={filters.start_date || ''}
                onChange={e => onDateChange('start_date', e.target.value)}
                size="small"
                variant="outlined"
                sx={{ minWidth: 150 }}
                InputLabelProps={{
                  shrink: true,
                }}
                error={!!dateErrors.start_date}
                helperText={dateErrors.start_date}
              />
              <TextField
                label="Fecha fin"
                type="date"
                value={filters.end_date || ''}
                onChange={e => onDateChange('end_date', e.target.value)}
                size="small"
                variant="outlined"
                sx={{ minWidth: 150 }}
                InputLabelProps={{
                  shrink: true,
                }}
                error={!!dateErrors.end_date}
                helperText={dateErrors.end_date}
              />
            </>
          )}
        </>
      )}
      {showPeriodFilter ? (
        <CustomSelect
          value={filters.section}
          setValue={onSectionChange}
          field={'section'}
          items={sections}
          label={'Secciones'}
        />
      ) : null}
      <SearchField
        value={filters.search}
        onChange={onSearchChange}
        label=""
        placeholder="Buscar..."
      />
    </Box>
  );
};

export default FilterBar;
